import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import CustomButton from "../components/CustomButton";
const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
  padding: 20px 0px;
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;
  @media (max-width: 767px) {
    order: 1;
  }
  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.2;
    margin-bottom: 15px;
    text-transform: uppercase;
    text-align: right;

    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
  > p {
    font-size: 16px;
    font-family: var(--montserrat);
    line-height: 1.5;
    margin-bottom: 5px;
    text-align: right;
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 567px) {
      font-size: 12px;
    }
  }
`;

const Right = styled.div`
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  @media (max-width: 767px) {
    order: 2;
  }
`;

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;
const MarketPlace = () => {
  const handleNavigate = () => {
    window.open("https://alpharegiment.in/", "_blank");
  };
  return (
    <>
      <CustomHelmet
        title="Arcaptor: Democratizing Education in India with Marketplaces"
        description="Arcaptor leverages innovative marketplaces to democratize education in India, making quality learning accessible, inclusive, and affordable for all."
      />
      <MainLayout>
        <Section>
          <Container>
            <Content>
              <Right>
                {" "}
                <img src="/images/marketplace.png" alt="marketPlace" />
              </Right>

              <Left>
                <h1>
                  Empowering educators to teach their way, with freedom and
                  passion.
                </h1>
                <p>#AlphaRegiment</p>
                <p>#AlphaUPSC</p>
              </Left>
            </Content>
          </Container>
        </Section>
        <Container>
          <TextContent>
            <h2 className="main_heading">
              Alpha Regiment – A Marketplace for Modern Learning and Preparation
            </h2>

            <p>
              <b>Alpha Regiment</b> is a comprehensive marketplace within the
              Arcaptor ecosystem that brings together the best{" "}
              <b>online and offline courses, services, and experts</b> for
              students across diverse learning goals. From competitive exam
              preparation to skill development, it offers a one-stop solution
              designed to support learners at every stage of their journey.
            </p>

            <br />

            <h4>Why Choose Alpha Regiment?</h4>
            <br />

            <ul>
              <li>
                <strong>1. Solutions for Every Stage:</strong> Whether it’s exam
                preparation, interviews, skill-building, or overall development,
                Alpha Regiment provides tailored solutions to meet every
                learner’s needs.
              </li>
              <li>
                <strong>2. Learn from the Best:</strong> Connect with top
                educators, experienced professionals, retired officers,
                trainers, and subject-matter experts who bring real-world
                insights into learning.
              </li>
              <li>
                <strong>3. Holistic Learning Support:</strong> Access a wide
                range of services—from academic guidance and mentorship to
                fitness, communication skills, and performance improvement—all
                in one place.
              </li>
              <li>
                <strong>4. Flexible Learning Modes:</strong> Choose between
                online and offline experiences, designed to fit different
                learning styles, schedules, and locations.
              </li>
            </ul>

            <br />

            <h4>For Educators, Trainers, and Experts</h4>
            <br />

            <p>
              Alpha Regiment is not just for learners—it is also a powerful
              platform for educators, trainers, and professionals to build and
              scale their offerings. With technology, tools, and distribution
              handled by us, you can focus entirely on teaching, mentoring, and
              creating impact.
            </p>

            <br />

            <h4>What Sets Alpha Regiment Apart</h4>
            <br />

            <ul>
              <li>
                <strong>All-in-One Marketplace:</strong> Everything a learner
                needs, in one unified platform.
              </li>
              <li>
                <strong>Expert-Led Ecosystem:</strong> High-quality content and
                guidance from trusted professionals.
              </li>
              <li>
                <strong>Integrated Learning Experience:</strong> Seamlessly
                connected with AI, simulation, and metaverse platforms.
              </li>
              <li>
                <strong>Smart Tools for Growth:</strong> Advanced systems to
                track, analyze, and improve performance.
              </li>
            </ul>

            <br />

            <h4>A Growing Ecosystem</h4>
            <br />

            <p>
              While Alpha Regiment has strong roots in defence and SSB
              preparation, it is rapidly expanding to support UPSC, school
              education (Class 6–12), and other competitive exams. Our vision is
              to build a multi-domain learning marketplace across India, and
              eventually scale globally, bringing high-quality, accessible
              education to learners everywhere.
            </p>

            <br />

            <h4>More Than a Marketplace</h4>
            <br />

            <p>
              Alpha Regiment is not just a platform—it’s a community of
              learners, mentors, and achievers. Whether you are starting your
              journey or aiming for excellence, it empowers you with the right
              resources, right guidance, and right ecosystem to succeed.
            </p>

            <br />

            <h4>
              Alpha Regiment — Your Partner in Learning, Growth, and Success.
            </h4>

            <CustomButton
              title="View Alpha Regiment"
              onClick={handleNavigate}
              width="180px"
              className="campus"
            />
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default MarketPlace;
